export const environment = {
  apilUrl: process.env.REACT_APP_API_URL
};

export const config = {
  appId: process.env.REACT_APP_AZURE_APP_ID,
  redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
  scope: [
    'user.read'
  ],
  authority: process.env.REACT_APP_AZURE_AUTHORITY
}